import { useEffect, useState } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';
import { TokenIcon } from './TokenIcon';

interface TokenCounterProps {
    totalTokens: number;
    className?: string;
}

export const TokenCounter = ({ totalTokens, className = '' }: TokenCounterProps) => {
    // Spring physics for smooth counting
    const springValue = useSpring(totalTokens, {
        stiffness: 75,
        damping: 15,
        mass: 1,
    });

    // Transform spring value to formatted string directly
    const displayValue = useTransform(springValue, (current) =>
        Math.round(current).toLocaleString('es-AR')
    );

    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        springValue.set(totalTokens);
        setIsAnimating(true);
        const timer = setTimeout(() => setIsAnimating(false), 1000);
        return () => clearTimeout(timer);
    }, [totalTokens, springValue]);

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <motion.div
                animate={isAnimating ? {
                    rotateY: [0, 180, 360],
                    scale: [1, 1.2, 1],
                    y: [0, -5, 0]
                } : {}}
                transition={{ duration: 0.8, ease: "easeInOut" }}
            >
                <TokenIcon size={32} />
            </motion.div>
            <div className="flex flex-col">
                <span className="text-sm font-medium text-gray-500">Créditos disponibles</span>
                <motion.span className="text-2xl font-bold text-gray-900 tracking-tight font-mono">
                    {displayValue}
                </motion.span>
            </div>
        </div>
    );
};
